import { StyledEngineProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { SnackbarProvider } from 'notistack';
import React, { useEffect } from 'react';
import I18nService from 'services/i18n/i18nService';
import ConfigGuard from 'components/ConfigGuard';
import ParametersGuard from 'components/ParametersGuard';
import AppContent from 'components/AppContent';
import { MUI_LICENSE_KEY, tenantConfig } from 'config';
import Environment from 'store/enums/Environment';
import SiteTheme from 'store/enums/SiteTheme';
import HttpServiceTracingInterceptorService from 'services/HttpServiceTracingInterceptorService';
import TagManager from 'react-gtm-module';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import RecaptchaProvider from 'components/recaptcha/RecaptchaProvider';

import './App.module.scss';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);

const tagManagerArgs = {
  gtmId: 'GTM-T87QC3P',
};

const App: React.FunctionComponent = () => {
  const { environment, theme } = tenantConfig;

  useEffect(() => {
    const title = document.getElementById('app-title');

    if (title) {
      title.textContent = tenantConfig.appTitle;
    }

    I18nService.init();
    HttpServiceTracingInterceptorService.init();

    if (environment === Environment.Production && theme === SiteTheme.Gamsd) {
      TagManager.initialize(tagManagerArgs);
    }
  }, [environment, theme]);

  return (
    <StyledEngineProvider injectFirst={true}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        iconVariant={{
          error: '',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ParametersGuard>
            <ConfigGuard>
              <RecaptchaProvider>
                <AppContent />
              </RecaptchaProvider>
            </ConfigGuard>
          </ParametersGuard>
        </LocalizationProvider>
      </SnackbarProvider>
    </StyledEngineProvider>
  );
};
export default App;
